import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { infoMsg, siteContent } from '@services/api'
import { Table, Button, Icon, Select, Row, Input } from 'antd'
import EditSiteContentPopup from '@components/Popup/EditSiteContentPopup'
import helper from './helper'
import FakeSmsPopup from '@components/Popup/FakeSmsPopup'

@inject((store: any) => {
    const { popupStore, authStore } = store
    return { popupStore, authStore }
})
@observer
export default class extends Component {
    constructor(props) {
        super(props)
        this.handleSetData = this.handleSetData.bind(this)
        this.createDataSource = this.createDataSource.bind(this)
        this.state = {
            data: [],
            lng: '',
            textFilter: '',
            type: '',
            lngs: [],
            types: []
        }
    }

    handleSetData = data => {
        this.setState({
            data: data.map(slot => {
                return { ...slot, keys: JSON.parse(slot.keys) }
            }),
            types: [...new Set(data.map(slot => slot.type))]
        })
    }

    createDataSource = () => {
        let arr = []
        let { data, lng, textFilter, type } = this.state

        data.map(slot => {
            let { id, type, updated_by } = slot
            Object.entries(slot.keys).map(([key, value]) =>
                arr.push({
                    id,
                    type,
                    lng: slot.lng,
                    updated_by,
                    key: { key, value }
                })
            )
        })
        return arr.filter(slot => {
            const { value } = slot.key
            return (!lng || slot.lng == lng) && (!type || slot.type == type) && value.includes(textFilter)
        })
    }

    async componentDidMount() {
        await infoMsg
            .getApiContent()
            .then(res => this.handleSetData(res.data))
            .catch(err => console.log(err))
        let lngs
        await siteContent.getSiteLngs().then(res => {
            lngs = res.data.map(slot => slot.lng)
        })
        this.setState({ lngs })
    }

    render() {
        const { data, lng, lngs, type, types, textFilter } = this.state
        let {
            authStore: { roles },
            popupStore: { togglePopup }
        } = this.props

        let columns = [
            {
                title: 'שפה',
                key: 'lng',
                width: 30,
                align: 'center',
                render: (_, record) => <span key={record.lng}>{record.lng}</span>
            },
            {
                title: 'סוג',
                key: 'type',
                width: 30,
                align: 'center',
                render: (_, record) => (
                    <span key={record.type}>{(helper[record.type] && helper[record.type].title) || record.type}</span>
                )
            },
            {
                title: 'מפתח',
                key: 'key',
                width: 140,
                align: 'center',
                render: (_, record) => (
                    <span
                        key={record.key.key}
                        style={{
                            color:
                                helper[record.type] && !!helper[record.type].keys[record.key.key] ? 'unset' : '#ff7300'
                        }}
                    >
                        {(helper[record.type] &&
                            helper[record.type].keys[record.key.key] &&
                            helper[record.type].keys[record.key.key].title) ||
                            record.key.key}
                    </span>
                )
            },
            {
                title: 'דינמיים',
                key: 'dynamics',
                width: 140,
                align: 'center',
                render: (_, record) => {
                    return (
                        <span key={record.key.key}>
                            {(helper[record.type] &&
                                helper[record.type].keys[record.key.key] &&
                                helper[record.type].keys[record.key.key].dynamics &&
                                Object.values(helper[record.type].keys[record.key.key].dynamics).join(', ')) ||
                                ''}
                        </span>
                    )
                }
            },
            {
                title: 'טקסט',
                key: 'text',
                width: 500,
                align: 'center',
                render: (_, record) => (
                    <>
                        {record.key.value.split(' ').map(word => (
                            <span style={{ color: word == '$n' ? 'red' : word[0] == '$' ? 'blue' : 'unset' }}>
                                {(word == '$n'
                                    ? 'אנטר'
                                    : word[0] == '$'
                                    ? (helper[record.type] &&
                                          helper[record.type].keys[record.key.key] &&
                                          helper[record.type].keys[record.key.key].dynamics[word.substring(0, 2)] +
                                              word.substring(2)) ||
                                      word
                                    : word) + ' '}
                            </span>
                        ))}
                    </>
                )
            },
            {
                title: '',
                key: 'edit',
                width: 50,
                align: 'center',
                render: (_, record) => {
                    let popParams =
                        record.type == 'SMS'
                            ? {
                                  lng: record.lng,
                                  key: record.key.key,
                                  value: record.key.value,
                                  id: record.id,
                                  handleSetData: this.handleSetData
                              }
                            : {
                                  ...record,
                                  handleSetData: this.handleSetData,
                                  isApiContent: true
                              }
                    return (
                        <Button
                            onClick={() => {
                                togglePopup(record.type == 'SMS' ? 'fakeSms' : 'editSiteContent', popParams)
                            }}
                            disabled={!roles.includes('admin')}
                        >
                            <Icon type="edit" />
                        </Button>
                    )
                }
            }
        ]
        if (roles.includes('developer')) {
            columns.push({
                title: '',
                key: 'delete',
                width: 50,
                align: 'center',
                render: (_, record) => {
                    return (
                        <Button
                            onClick={() => {
                                infoMsg
                                    .deleteContent({ id: record.id, key: record.key.key })
                                    .then(res => this.handleSetData(res.data))
                            }}
                        >
                            <Icon type="delete" />
                        </Button>
                    )
                }
            })
        }

        return (
            <div style={{ flexDirection: 'column', display: 'flex' }}>
                <Row gutter={28} style={{ marginRight: '0.5rem', marginLeft: '0.5rem' }}>
                    <Select
                        id="set_lng"
                        value={lng}
                        style={{ width: '33%' }}
                        placeholder="בחר שפה"
                        onChange={lng => this.setState({ lng })}
                    >
                        <Select.Option value={''} key={'empty'}>
                            כל השפות
                        </Select.Option>
                        {lngs.map(slot => (
                            <Select.Option value={slot} key={slot}>
                                {slot}
                            </Select.Option>
                        ))}
                    </Select>
                    <Select
                        id="set_type"
                        value={type}
                        style={{ width: '33%' }}
                        placeholder="בחר סוג"
                        onChange={type => this.setState({ type })}
                    >
                        <Select.Option value={''} key={'empty'}>
                            כל הסוגים
                        </Select.Option>
                        {types.map(slot => (
                            <Select.Option value={slot} key={slot}>
                                {(helper[slot] && helper[slot].title) || slot}
                            </Select.Option>
                        ))}
                    </Select>
                    <Input
                        value={textFilter}
                        placeholder="לפי טקסט"
                        onChange={e => this.setState({ textFilter: e.target.value })}
                        style={{ width: '33%' }}
                    />
                </Row>
                <Row
                    gutter={28}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        marginTop: '1.5rem',
                        marginBottom: '1.5rem',
                        alignItems: 'center'
                    }}
                >
                    <span style={{ fontWeight: 800, fontSize: '1.5rem' }}>מקרא:</span>
                    <span style={{ color: 'blue' }}>טקסט כחול = טקסט דינמי</span>
                    <span style={{ color: 'red' }}>אנטר</span>
                </Row>
                <Table
                    loading={!data.length}
                    rowKey={(_, idx) => idx}
                    dataSource={this.createDataSource()}
                    columns={columns}
                />
                <EditSiteContentPopup />
                <FakeSmsPopup />
            </div>
        )
    }
}
